import { createFileRoute } from '@tanstack/react-router'

import { PayerExperienceScreen } from './-components/payer-experience-screen.tsx'

export const Route = createFileRoute('/payments/payer-experience')({
  component: PayerExperienceScreen
})
